import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import SalesList from "./pages/SalesList";
import SalesForm from "./pages/SalesForm";
import SalesDetail from "./pages/SalesDetail";
import TaskQueue from "./pages/TaskQueue";
import PdiQueue from "./pages/PdiQueue";
import PdiWorkspace from "./pages/PdiWorkspace";
import Admin from "./pages/Admin";
import WorkflowStagesMaster from "./pages/WorkflowStagesMaster";
import SalesPrint from "./pages/SalesPrint";
import AccountsQueue from "./pages/AccountsQueue";
import AccountsWorkspace from "./pages/AccountsWorkspace";
import BackOfficeQueue from "./pages/BackOfficeQueue";
import BackOfficeWorkspace from "./pages/BackOfficeWorkspace";
import RoadTaxWorkbench from "./pages/RoadTaxWorkbench";
import SparesQueue from "./pages/SparesQueue";
import SparesWorkspace from "./pages/SparesWorkspace";
import DeliveryFilesQueue from "./pages/DeliveryFilesQueue";
import DeliveryFileDetail from "./pages/DeliveryFileDetail";
import PrintDeliveryFile from "./pages/PrintDeliveryFile";
import DesignPreview from "./pages/DesignPreview";
import Reports from "./pages/Reports";
import SlaEscalationLog from "./pages/SlaEscalationLog";

export default function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/design-preview" element={<DesignPreview />} />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/sales" element={<SalesList />} />
              <Route path="/sales/new" element={<SalesForm />} />
              <Route path="/sales/:id/edit" element={<SalesForm />} />
              <Route path="/sales/:id/print" element={<SalesPrint />} />
              <Route path="/sales/:id" element={<SalesDetail />} />
              <Route path="/tasks" element={<TaskQueue />} />
              <Route path="/pdi" element={<PdiQueue />} />
              <Route path="/pdi/:saleId" element={<PdiWorkspace />} />
              <Route path="/accounts" element={<AccountsQueue />} />
              <Route path="/accounts/:saleId" element={<AccountsWorkspace />} />
              <Route path="/back-office" element={<BackOfficeQueue />} />
              <Route path="/back-office/road-tax/:saleId" element={<RoadTaxWorkbench />} />
              <Route path="/back-office/:taskType/:saleId" element={<BackOfficeWorkspace />} />
              <Route path="/spares" element={<SparesQueue />} />
              <Route path="/spares/:saleId" element={<SparesWorkspace />} />
              <Route path="/delivery-files" element={<DeliveryFilesQueue />} />
              <Route path="/delivery-files/:saleId/print" element={<PrintDeliveryFile />} />
              <Route path="/delivery-files/:saleId" element={<DeliveryFileDetail />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="/admin/sla-escalations" element={<SlaEscalationLog />} />
              <Route path="/admin/workflow-stages" element={<WorkflowStagesMaster />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}
